import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Scrolls to the hash target on navigation, otherwise to the top of the new screen. */
export function ScrollManager() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        requestAnimationFrame(() => el.scrollIntoView({
          block: 'start'
        }));
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}